import moment from "moment";
import __ from "lodash";

const getSeason = (seasons, fromDate) => {

  if ( seasons && Array.isArray(seasons) ) {
    const season = __.find(seasons, function (o) {
      const seasonStart = moment.utc(o.seasonsStarts);
      const seasonEnd = moment.utc(o.seasonsEnds);
      const date = moment(fromDate);
      return (date.isBetween(seasonStart, seasonEnd, undefined, "[]"));
    })
    return season;
  }
  return null;
}


export {
  getSeason
}
